/**
 * @group Constants
 * @internal
 *
 * @example
 * ```typescript
 * import { SERVICE_REGISTRY_MESSAGES } from '@shared/reporting';
 *
 * console.error(SERVICE_REGISTRY_MESSAGES.NO_SERVICES_FOUND); // 'No services found to handle this event type'
 * ```
 */
export const SERVICE_REGISTRY_MESSAGES = {
  NO_SERVICES_FOUND: 'No services found to handle this event type',
  NO_SERVICES_FOUND_CODE: 'NO_SERVICES_FOUND',
  CONSOLE_VALIDATION_FAILED: 'Console event validation failed',
  CONSOLE_VALIDATION_FAILED_CODE: 'CONSOLE_VALIDATION_FAILED',
  POSTHOG_VALIDATION_FAILED: 'PostHog event validation failed',
  POSTHOG_VALIDATION_FAILED_CODE: 'POSTHOG_VALIDATION_FAILED'
} as const;
